import Cookies from 'js-cookie';

// Open enrollment banner: revealed only when the user has not dismissed it.
// Dismissal is stored in a cookie that expires after 2 days so the banner does
// not reappear on every page change. Visibility is handled here (not in PHP) so
// the markup stays cacheable on Pantheon.

const COOKIE_NAME = 'oe_banner_dismissed';
const COOKIE_EXPIRY_DAYS = 2;

const banner = document.getElementById('oeBanner');

if (banner) {
    const closeBtn = document.getElementById('oeBannerClose');

    // Keep the fixed navbar and page content offset by the banner's height while
    // it is visible. Measured live so a wrapped message on mobile still fits.
    function syncOffset() {
        const height = banner.offsetHeight;
        document.body.style.setProperty('--oe-banner-h', `${height}px`);
    }

    function showBanner() {
        banner.hidden = false;
        banner.classList.add('oe-banner--visible');
        document.body.classList.add('oe-banner-active');
        syncOffset();
        window.addEventListener('resize', syncOffset);
    }

    function hideBanner() {
        banner.classList.remove('oe-banner--visible');
        banner.hidden = true;
        document.body.classList.remove('oe-banner-active');
        document.body.style.removeProperty('--oe-banner-h');
        window.removeEventListener('resize', syncOffset);
    }

    if (Cookies.get(COOKIE_NAME) !== '1') {
        showBanner();
    }

    if (closeBtn) {
        closeBtn.addEventListener('click', () => {
            Cookies.set(COOKIE_NAME, '1', { expires: COOKIE_EXPIRY_DAYS, path: '/' });
            hideBanner();
        });
    }
}
